import { CheckCircle2, Clock, FileText, XCircle } from 'lucide-react';

const statuts: Record<string, { label: string; classe: string; Icone: any }> = {
  valide: {
    label: 'Validé par le bureau',
    classe: 'text-green-700 dark:text-green-400',
    Icone: CheckCircle2,
  },
  en_attente: {
    label: 'En attente de validation',
    classe: 'text-amber-700 dark:text-amber-400',
    Icone: Clock,
  },
  refuse: {
    label: 'Refusé',
    classe: 'text-red-700 dark:text-red-400',
    Icone: XCircle,
  },
};

/**
 * Aperçu d'un visuel déjà détenu par le comité.
 *
 * Un PDF ou un fichier vectoriel ne s'affiche pas dans une balise image : on
 * montre alors une vignette de document plutôt qu'un cadre vide, avec le nom
 * du fichier — c'est lui qui permet au sponsor de reconnaître ce qu'il avait
 * envoyé.
 */
export default function VisuelDetenu({
  titre,
  fichier,
}: {
  titre: string;
  fichier: any | null;
}) {
  if (!fichier) {
    return (
      <div className="rounded-xl border border-dashed border-gray-200 dark:border-gray-700 p-4">
        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{titre}</p>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          Le comité n'en détient pas encore. Déposez-le ci-dessous.
        </p>
      </div>
    );
  }

  const statut = statuts[fichier.statutValidation] ?? statuts.en_attente;
  const { Icone } = statut;

  return (
    <div className="rounded-xl border border-gray-200 dark:border-gray-700 p-4 flex items-start gap-3">
      <div className="w-20 h-20 rounded-lg border border-gray-100 dark:border-gray-800 bg-white flex items-center justify-center overflow-hidden shrink-0">
        {fichier.previsualisable ? (
          <img
            src={fichier.url}
            alt={fichier.nomOriginal ?? titre}
            className="w-full h-full object-contain"
          />
        ) : (
          <FileText className="w-8 h-8 text-gray-400" />
        )}
      </div>

      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{titre}</p>
        <p className="text-xs text-gray-500 dark:text-gray-400 truncate">
          {fichier.nomOriginal} · {fichier.tailleFormatee}
        </p>
        <p className={`text-xs mt-1 inline-flex items-center gap-1 ${statut.classe}`}>
          <Icone className="w-3.5 h-3.5" />
          {statut.label}
        </p>
        {fichier.statutValidation === 'refuse' && fichier.motifRefus && (
          <p className="text-xs text-red-700 dark:text-red-400 mt-1">{fichier.motifRefus}</p>
        )}
        <a
          href={fichier.url}
          target="_blank"
          rel="noreferrer"
          className="text-xs text-primary-700 dark:text-primary-400 hover:underline mt-1 inline-block"
        >
          Ouvrir le fichier
        </a>
      </div>
    </div>
  );
}
